import React from 'react';
import PropTypes from 'prop-types';
import ConditionalRender
  from '@avtechsoftware/react-component-library/src/components/common/ConditionalRender/ConditionalRender';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import { useSelector } from 'react-redux';
import alertPropType from '../../../../../utility/PropTypes/alertPropType';
import { selectNotificationGroupList } from '../../../../../redux/slices/notificationGroupsSlice/notificationGroupsSlice';

function QuickAlertConfirmationPage(props) {
  const {
    hasAdvancedAlerting,
    quickAlertsData,
  } = props;
  const { alertActions } = quickAlertsData[0];
  const notificationGroups = useSelector(selectNotificationGroupList);

  const renderActionInformation = (actions) => actions
    .flatMap((action) => notificationGroups
      .filter((group) => action.notificationGroupIds.includes(group.id))
      .map((ng) => ng.name))
    .join(', ');

  const handleNavigateToAlerts = () => {
    window.location.href = '/s/alerts';
  };

  return (
    <div className="card">
      <div className="card-body">

        <ConditionalRender show={hasAdvancedAlerting}>
          <div className="card-body">
            <h5 className="card-title">
              Alerts created
              {' '}
              <Icon icon="check" className="text-success" />
            </h5>
            <div className="card-text">
              {`You'll see two new alerts in your list: "${quickAlertsData[0].alert.description}" and "${quickAlertsData.length > 1 && quickAlertsData[1].alert.description}".`}
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title">
              {`${quickAlertsData[0].alertActions.length
          > 1 ? 'Actions' : 'Action'} tested`}
              {' '}
              <Icon icon="check" className="text-success" />
            </h5>
            <div className="card-text">
              <ConditionalRender show={quickAlertsData[0].alertActions.length > 1}>
                <p>
                  {`Room Alert Account sent test notifications
          to ${renderActionInformation(alertActions)}.`}
                </p>
                <i>Please Check that you received them.</i>
              </ConditionalRender>
              <ConditionalRender show={quickAlertsData[0].alertActions.length === 1}>
                <p>
                  {`Room Alert Account sent a test notification
          to ${renderActionInformation(alertActions)}.`}
                </p>
                <i>Please Check that you received it.</i>
              </ConditionalRender>
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title">
              Next steps...
            </h5>
            <div className="card-text">
              You can create additional alerts for the various conditions your Room Alert monitors,
              {' '}
              including switch state, humidity, heat index, electrical current and more.
              <br />
              <br />
              <i>
                For instructions, please see
                {' '}
                <a
                  href="https://avtech.com/articles/223/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  How To Create Alerts In Your RoomAlert.com Account.
                </a>
              </i>
            </div>
          </div>
        </ConditionalRender>

        <ConditionalRender show={!hasAdvancedAlerting}>
          <div className="card-body">
            <h5 className="card-title">
              Alert created
              {' '}
              <Icon icon="check" className="text-success" />
            </h5>
            <div className="card-text">
              {`You'll see one new alert in your list: "${quickAlertsData[0].description}".`}
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title">
              Action tested
              {' '}
              <Icon icon="check" className="text-success" />
            </h5>
            <div className="card-text">
              <p>
                {`Room Alert Account sent a test notification
           to ${renderActionInformation(quickAlertsData[0].alertActions)}.`}
              </p>
              <i>Please Check that you received it.</i>
            </div>
          </div>
          <div className="card-body">
            <h5 className="card-title">
              Next steps...
            </h5>
            <div className="card-text">
              Consider
              {' '}
              <a target="_blank" href="/s/subscription/billing/change-plan">
                upgrading your account
              </a>
              {' '}
              in order to create additional alerts
              {' '}
              for the various conditions your Room Alert monitors,
              {' '}
              including switch state, humidity, heat index, electrical current and more.
            </div>
          </div>
        </ConditionalRender>

        <div className="text-center py-3">
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleNavigateToAlerts}
          >
            Go to Alerts List
          </button>
        </div>
      </div>
    </div>
  );
}

QuickAlertConfirmationPage.propTypes = {
  hasAdvancedAlerting: PropTypes.bool.isRequired,
  quickAlertsData: PropTypes.arrayOf(PropTypes.shape(alertPropType)).isRequired,
};

export default QuickAlertConfirmationPage;
